export const Images = {
  WALLET: require('./wallet.svg'),
  DISCONNECT: require('./disconnect.svg'),
  BRANDLOGO: require('./MOJITO.svg'),
  DISCORD: require('./Socialmedia.svg'),
  ETHICON: require('./ethIcon.svg'),
  LOGO_ICON: require('./logo.svg'),
  METAMASK: require('./MetaMask.svg'),
  WALLET_CONNECT: require('./walletConnect.svg'),
  LOADER: require('./loader.gif'),
  MATIC: require('./Matic.svg'),
  WETH_ICON: require('./WETH.svg'),
  PLACEHOLDER: require('./placeholder.svg'),
  DISCORD_SOCIAL: require('./discord.svg'),
  LINKEDIN: require('./linkedin.svg'),
  REDDIT: require('./redit.svg'),
  TELEGRAM: require('./telegram.svg'),
  FACEBOOK: require('./facebook.svg'),
  CARD_IMG: require('./placeholder.png'),
  PREVIEW_IMAGE: require('./preview.png'),
  KINETEK_LOGO: require('./kinetek-logo.svg')
};
